<template>

  <div class="container" style="padding: 0;">
    <el-carousel id="test_videos_list"
                 indicator-position="none"
                 :autoplay="false"
                 :type="carouselType"
                 :height="carouselHeight" @change="pictureChanged">
      <el-carousel-item v-for="(item, index) in videoList" :key="'video-item-card-' + index">
        <div style="position: relative;">
          <el-image  :src="postImg(item)" fit="scale-down">
          </el-image>

          <a class="iconfont"
             @click="playButtonClicked(item)"
             href="javascript:void(null);">&#xe6eb;</a>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="videos-full-outer"  v-if="showVideo">
      <video
        id="home_page_video"
        type="video/mp4"
        autoplay
        controls
      >
        <source :src="videoUrl" type="video/mp4">
        您的浏览器不支持 HTML5 video 标签。
      </video>
      <a>
        <img class="close-button" href="javascript:void(0);"
             @click="closeButtonClicked"
             src="../../assets/shl_video_close_btn.png">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideosCarousel",
  props: [
    'videoList',
  ],
  data() {
    return {
      showVideo: false,
      videoUrl: '',
      carouselType: 'card',
      carouselHeight: '300px',
    }
  },
  computed: {

  },
  mounted() {
    $(window).resize(this.updateStatus);
    this.updateStatus();
  },
  methods: {
    pictureChanged(index) {
      console.log(index);
      this.$emit('video-changed', {index});
    },
    updateStatus() {
      let width = window.screen.width;
      if (width >= 768) {
        this.carouselType = 'card';
        this.carouselHeight = '300px';
      } else {
        this.carouselType = '';
        this.carouselHeight = '200px';
      }
    },

    postImg(item) {
      let videoUrl = item.url;
      if (videoUrl != null && videoUrl.length > 0) {
        let temp = videoUrl.split('?');
        // console.log(temp);
        return temp.length > 0 ? temp[0] : '';
      }
      return '';
    },
    getVideoUrl (item) {
      let videoUrl = item.url;
      if (videoUrl != null && videoUrl.length > 0) {
        let temp = videoUrl.split('?');
        return temp.length == 2 ? temp[1] : '';
      }
      return '';
    },
    playButtonClicked(item) {

      let videoUrl = this.getVideoUrl(item);
      this.videoUrl = videoUrl;
      this.showVideo = true;
      // console.log('----1');
      // this.$emit('playVideo', {
      //   url: videoUrl
      // });
    },
    closeButtonClicked() {
      this.showVideo = false;
      this.videoUrl = '';
    }
  }
}
</script>

<style scoped>

  #test_videos_list {
    /*width: 100%;*/
  }

  #test_videos_list .el-carousel__item {
    /*background-color: yellow;*/
  }

  #test_videos_list .el-carousel__item .el-image {
    height: 100%;
    width: 100%;
  }

  #test_videos_list .el-carousel__item .iconfont {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 2rem;
    color: white;
  }


  /*#test_videos_list .el-carousel__item:nth-child(2n) {*/
  /*  background-color: #99a9bf;*/
  /*}*/

  /*#test_videos_list .el-carousel__item:nth-child(2n+1) {*/
  /*  background-color: #d3dce6;*/
  /*}*/


  .videos-full-outer {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0,0,0,0.3);
    left: 0;
    top: 0;
    z-index: 999;
  }

  .videos-full-outer  a {
    text-decoration: none;
  }

  .videos-full-outer .close-button {
    width: 20px;
    position: absolute;
    top: 45px;
    right: 15px;
    height: auto;
  }

  @media screen and (min-width: 768px) {
    .videos-full-outer .close-button {
      top: 15px;
      width: 30px;
    }
  }

  .videos-full-outer video {
    width: 100%;
    height: 100%;
    background-color: black;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/VideosCarousel.vue